import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./App";
import "./index.css";

// Build-time static generation + client hydration. vite-react-ssg renders each
// static route to real HTML (body + per-route <head> via <Seo>/<Head>), then
// hydrates on the client. Node-only build — no headless browser required.
export const createRoot = ViteReactSSG({ routes });
